import React from 'react';
import './ViewUserModal.css';

const ViewUserModal = ({ user, onClose }) => {
  if (!user) return null;

  const formatCurrency = (amount, currency = 'USD') => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency
    }).format(amount);
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="view-user-modal-overlay" onClick={onClose}>
      <div className="view-user-modal" onClick={(e) => e.stopPropagation()}>
        <div className="view-user-modal-header">
          <h2>User Details - {`${user.firstName || ''} ${user.lastName || ''}`.trim() || 'Unknown User'}</h2>
          <button className="view-user-modal-close" onClick={onClose}>×</button>
        </div>

        <div className="view-user-modal-content">
          {/* Basic Information */}
          <div className="admin-user-info-section">
            <h3>Basic Information</h3>
            <div className="admin-user-info-grid">
              <div className="admin-user-info-item">
                <label>User ID:</label>
                <span>{user.id}</span>
              </div>
              <div className="admin-user-info-item">
                <label>Full Name:</label>
                <span>{`${user.firstName || ''} ${user.lastName || ''}`.trim() || 'N/A'}</span>
              </div>
              <div className="admin-user-info-item">
                <label>Email:</label>
                <span>{user.email}</span>
              </div>
              <div className="admin-user-info-item">
                <label>Role:</label>
                <span className={`admin-user-role-badge admin-user-role-${user.role?.toLowerCase()}`}>
                  {user.role || 'USER'}
                </span>
              </div>
              <div className="admin-user-info-item">
                <label>Status:</label>
                <span className={`admin-user-status-badge admin-user-status-${user.isActive ? 'active' : 'inactive'}`}>
                  {user.isActive ? 'Active' : 'Inactive'}
                </span>
              </div>
              <div className="admin-user-info-item">
                <label>Verified:</label>
                <span className={`admin-user-verified-badge admin-user-verified-${user.isVerified ? 'verified' : 'unverified'}`}>
                  {user.isVerified ? 'Verified' : 'Unverified'}
                </span>
              </div>
              <div className="admin-user-info-item">
                <label>Join Date:</label>
                <span>{formatDate(user.createdAt)}</span>
              </div>
              <div className="admin-user-info-item">
                <label>Last Updated:</label>
                <span>{formatDate(user.updatedAt)}</span>
              </div>
            </div>
          </div>

          {/* Wallet Information */}
          <div className="admin-user-info-section">
            <h3>Wallet Information</h3>
            <div className="admin-user-info-grid">
              {user.wallet ? (
                <>
                  <div className="admin-user-info-item">
                    <label>Balance:</label>
                    <span className="admin-user-balance">
                      {formatCurrency(user.wallet.balance || 0, user.wallet.currency || 'USD')}
                    </span>
                  </div>
                  <div className="admin-user-info-item">
                    <label>Currency:</label>
                    <span>{user.wallet.currency || 'USD'}</span>
                  </div>
                  <div className="admin-user-info-item">
                    <label>Wallet ID:</label>
                    <span>{user.wallet.id}</span>
                  </div>
                  <div className="admin-user-info-item">
                    <label>Wallet Created:</label>
                    <span>{formatDate(user.wallet.createdAt)}</span>
                  </div>
                </>
              ) : (
                <div className="admin-user-info-item admin-user-no-wallet">
                  <span>No wallet associated with this user</span>
                </div>
              )}
            </div>
          </div>


          {/* Recent Activity */}
          {user.recentBets && user.recentBets.length > 0 && (
            <div className="admin-user-info-section">
              <h3>Recent Bets</h3>
              <div className="admin-user-recent-bets">
                {user.recentBets.slice(0, 5).map((bet, index) => (
                  <div key={bet.id || index} className="admin-user-bet-item">
                    <div className="admin-user-bet-info">
                      <span className="admin-user-bet-tournament">{bet.tournament?.name || 'Unknown Tournament'}</span>
                      <span className="admin-user-bet-amount">{formatCurrency(bet.amount)}</span>
                    </div>
                    <div className="admin-user-bet-status">
                      <span className={`admin-user-bet-status-badge admin-user-bet-status-${bet.status?.toLowerCase()}`}>
                        {bet.status || 'Unknown'}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="view-user-modal-footer">
          <button className="admin-btn admin-btn-secondary" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewUserModal;
